import { useContext } from "react"
import { OrganizationMembershipContext } from "../../context/OrganizationMembershipContext"

export function useOrganizationMembership() {
  const organizationMembership = useContext(OrganizationMembershipContext)

  return organizationMembership
}
